import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const EmailTemplateDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [

  ],
  subscriptions: {

  },
  defaultColumns: [
  
  ],
  columnConfig: {

  }
}